import { useState } from "react";
import { Button, Container, Row } from "react-bootstrap";
import "./Myskill.css";
import OtherSkills from "./OtherSkills";
import ProgrammingSkill from "./ProgrammingSkill";
import WebSkills from "./WebSkills";

export default function MySkill() {
  const [showSkill, setShowSkill] = useState("web");
  return (
    <div className="mt-5 mb-4 skills" id="skills">
      <Container>
        <Row>
          <div className="col-md-12 col-sm-12 pt-4 mb-5 col-12 text-center heading">
            <h6>
              <span>SKILLS</span>
            </h6>
          </div>
          <div className="col-md-12 col-sm-12 col-12 mySkillsContainer d-flex align-items-center justify-content-center">
            <Row style={{ width: "100%" }}>
              <div className="col-md-12 col-sm-12 col-12 mb-5">
                <div className="d-flex">
                  <Button onClick={() => setShowSkill("web")} className="mx-2  my-2">
                    Web
                  </Button>
                  <Button onClick={() => setShowSkill("programming")} className="my-2  mx-2">
                    Programming
                  </Button>
                  <Button onClick={() => setShowSkill("other")} className="my-2  mx-2">
                    Other
                  </Button>
                </div>
              </div>
              <div className="col-md-12 col-sm-12 col-12 allSkillsRender">
                <Row>
                  {showSkill === "web" ? <WebSkills /> : null}
                  {showSkill === "programming" ? <ProgrammingSkill /> : null}
                  {showSkill === "other" ? <OtherSkills /> : null}
                </Row>
              </div>
            </Row>
          </div>
        </Row>
      </Container>
    </div>
  );
}
